class FiskaltrustController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'RegisterRepository'
		'BACKEND_REGISTER_ENTITY_TYPE'

	integrationId: 'fiskaltrust'

	initialize: ->
		@getRegisters()

	save: ->
		super(@configuration)

	afterDisconnect: ->
		@configuration = {}

	getRegisters: ->
		query = @RegisterRepository.createQuery()
		query.sortBy 'shop.name', 'ASC'
		query.with 'shop'

		criteria = query.criteria 'entity_type', '=', @BACKEND_REGISTER_ENTITY_TYPE.POS
		criteria.or 'entity_type', '=', @BACKEND_REGISTER_ENTITY_TYPE.KDS

		return @RegisterRepository
			.getEntities(query)
			.then (response) =>
				@registers = response

	validateForm: (registers) ->
		@mainForm.$valid = @validateRegistersConfigurations(registers)

	validateRegistersConfigurations: (registers) ->
		for own key, register of registers
			if !register.cashbox_id || !register.access_token
				return false

		return true
